import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import { useUser } from '@unisporkal/user';
import { useExperience } from '@unisporkal/experiences';
import InfoTooltip from '../../../InfoTooltip/InfoTooltip';
import styles from '../Messages.module.scss';
import { useAsset } from '../../../../hooks/stateful/useAsset';
import useOnLoad from '../../../../hooks/queries/useOnLoad';

const RoyaltyFreeCompanyMessage = () => {
  const t = useTranslations();
  const user = useUser();
  const limitedUseExperience = useExperience('GettyLimitedUseProducts');
  const { response: { limitedUseProducts } = {} } = useOnLoad();
  const { asset } = useAsset();

  const showRFCompanyMessage =
    user.companyId &&
    limitedUseExperience.isActive() &&
    asset.isImage() &&
    asset.isRoyaltyFree() &&
    !asset.isEditorial() &&
    limitedUseProducts?.length > 0;

  if (!showRFCompanyMessage) return null;
  return (
    <div
      className={styles.buyCardHeading}
      data-testid="royaltyFreeCompanyMessage"
    >
      {t('limited_use_rf_title')}
      <InfoTooltip content={t('limited_use_rf_tooltip')} />
    </div>
  );
};

export default RoyaltyFreeCompanyMessage;
